module.exports = __webpack_public_path__ + "static/media/Pillnotes_Home_Cat.92e30bd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/LandingPage/images/Pillnotes_Home_Cat.png
// module id = 1452
// module chunks = 0